export default __webpack_public_path__ + "static/media/stereo_01.d2890e97.gif";